import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const purchaceFilter: ILayoutFilter[] = [
  {
    id: 'empresaIds',
    label: 'Empresa',
    type: 'checkbox'
  },
  {
    id: 'empresaSelectIds',
    label: '',
    filterId: 'companies',
    type: 'select',
    isMulti: true
  },
  {
    id: 'centroCdLojaIds',
    label: 'Centro (CD/Loja)',
    type: 'checkbox'
  },
  {
    id: 'centroCdLojaSelectIds',
    label: '',
    filterId: 'centers',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'gerenteCategoriaIds',
  //   label: 'Gerente de Categoria',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'gerenteCategoriaSelectIds',
  //   label: '',
  //   filterId: 'categoryManagers',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'gerenteProdutoIds',
    label: 'Gerente de Produto',
    type: 'checkbox'
  },
  {
    id: 'gerenteProdutoSelectIds',
    label: '',
    filterId: 'productManagers',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'mundoIds',
  //   label: 'Mundo',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'mundoSelectIds',
  //   label: '',
  //   filterId: 'worlds',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'categoriaCompactaIds',
    label: 'Categoria Compacta',
    type: 'checkbox'
  },
  {
    id: 'categoriaCompactaSelectIds',
    label: '',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriaIds',
    label: 'Categoria',
    type: 'checkbox'
  },
  {
    id: 'categoriaSelectIds',
    label: '',
    filterId: 'categories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'subCategoriaIds',
    label: 'Sub Categoria',
    type: 'checkbox'
  },
  {
    id: 'subCategoriaSelectIds',
    label: '',
    filterId: 'subCategories',

    type: 'select',
    isMulti: true
  },
  {
    id: 'curvaAbcIds',
    label: 'Curva',
    type: 'checkbox'
  },
  {
    id: 'curvaAbcSelectIds',
    label: '',
    filterId: 'abcCurves',
    type: 'select',
    isMulti: true
  },
  {
    id: 'fornecedorIds',
    label: 'Fornecedor',
    type: 'checkbox',
    isDisabled: true
  },
  {
    id: 'fornecedorSelectIds',
    label: '',
    filterId: 'providersForDistribution',
    type: 'select',
    isMulti: true
  }
]
